import axios from "axios";

let currentAudio = null;

export const stopSpeechKokoro = () => {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }
};

export const playSpeechKokoro = async (text) => {
  try {
    // Stop previous speech
    stopSpeechKokoro();

    const response = await axios.get(
      "https://admin.fefdybraingym.com/v1/tts",
      {
        params: { text },
      }
    );

    console.log("Response:", response.data);
    console.log("URL:", response.data.data.url);

    currentAudio = new Audio(response.data.data.url);

    currentAudio.onloadedmetadata = () => {
      console.log("Loaded metadata");
    };

    currentAudio.oncanplay = () => {
      console.log("Can play");
    };

    currentAudio.onerror = () => {
      console.log("Audio error");
      console.log(currentAudio.error);
      console.log(currentAudio.src);
    };

    await currentAudio.play();

  } catch (err) {
    console.error(err);
  }
};